import React from "react";

/**
 * Componente per l'intestazione standard delle pagine
 * @param {Object} props - Proprietà del componente
 * @param {string} props.title - Titolo della pagina
 * @param {JSX.Element} props.actions - Eventuali azioni/bottoni da mostrare a destra
 * @param {string} props.subtitle - Eventuale sottotitolo
 * @returns {JSX.Element}
 */
const PageHeader = ({ title, actions, subtitle }) => {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 pb-4 border-b border-gray-200">
      <div>
        <h1 className="text-2xl font-semibold text-gray-800">{title}</h1>
        {subtitle && (
          <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
        )}
      </div>
      {actions && (
        <div className="mt-4 sm:mt-0">
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
